import { useEffect, useState } from 'react';
import { api } from '../api';

// A rendered PDF page as a small JPEG blob URL — the thumbnail of a document
// detected INSIDE a compilation file (its first page is a page of the parent).
// Same shape as useThumbnailUrl; keyed by (docId, page). `enabled` lets the
// gallery defer the fetch until the card scrolls into view.
const _cache = new Map();
const WIDTH = 320;
const QUALITY = 70;

export function usePageThumbnailUrl(docId, page, enabled = true) {
  const key = docId && page ? `${docId}:${page}` : null;
  const [src, setSrc] = useState(() => (key ? _cache.get(key) || null : null));
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!key || !enabled) return undefined;
    const cached = _cache.get(key);
    if (cached) { setSrc(cached); setError(null); return undefined; }
    let cancelled = false;
    setError(null);
    api.raw('GET', `/documents/${docId}/page/${page}?width=${WIDTH}&quality=${QUALITY}`)
      .then((res) => { if (!res.ok) throw new Error(`HTTP ${res.status}`); return res.blob(); })
      .then((blob) => {
        if (cancelled) return;
        const url = URL.createObjectURL(blob);
        _cache.set(key, url);
        setSrc(url);
      })
      .catch((err) => { if (!cancelled) setError(err.message); });
    return () => { cancelled = true; };
  }, [key, docId, page, enabled]);

  return { src, error };
}
